import { API } from "aws-amplify";

class AirlinesService {
  getAirlines = async () => {
    var ReturnObj = [];
    await API.get("IAPI", "Airlines/airlines/")
      .then((res) => {
        ReturnObj = res;
        return res;
      })
      .catch((error) => {
        return error;
      });
    return ReturnObj;
  };

  getAirlinesOptions() {
    return API.get("IAPI", "Airlines/airlines/")
      .then((data) => {
        return data.map((item) => ({
          value: item.airlineCode,
          label: item.airline,
          isDisabled: !item.isActive,
          countryCode: item.countryCode,
        }));
      })
      .catch((error) => {
        //console.log(error);
        return [];
      });
  }

  GetAirlinesWithoutAdministrator() {
    return API.get("IAPI", "Airlines/airlinesWithoutAdministrator/")
      .then((res) => {
        return res.map((item) => ({
         value: item.airlineCode,
         label: item.airline,
         isDisabled: !item.isActive,
         countryCode: item.countryCode,
       }));
      })
      .catch((error) => {
        //console.log(error);
        return [];
      });
  };

  getUserAirline = async (airlineCode) => {    
    var ReturnObj = {};
    await API.get("IAPI", "Airlines/getUserAirline/", {
      queryStringParameters: {
        AirlineCode: airlineCode,
      },
    })
      .then((res) => {
        ReturnObj = res;
        return res;
      })
      .catch((error) => {
        return error;
      });
    return ReturnObj;
  };
}

export default new AirlinesService();
